/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 活动标题
   */
  title: string;
  /**
   * 活动开始时间（单位：秒）
   */
  start_time: number;
  /**
   * 活动结束时间（单位：秒）
   */
  end_time: number;
  /**
   * 收费类型（免费传1，付费传2，免费+付费传3）
   */
  charge_type: number;
  /**
   * 创建方式（快速创建传0，手动创建传1）
   */
  create_type: number;
  /**
   * 是否公开（不公开传0，公开传1）
   */
  is_public: number;
  /**
   * 缺省值为登录态对应的主办方ID
   */
  host_id?: string;

  /**
   * 封面图 cosid
   */
  cover_image: string;

  cover_image_url: string;
  /**
   * 准入规则 0-门票准入 1-无限制准入
   */
  access_rule: number;
  /**
   * 封面图cosid
   */
  cover_image: string;
  /**
   * 活动模板类型，空字符-默认，summit-行业峰会，salon-沙龙研讨会，training-培训课程
   */
  template: string;
}
export interface DashboardEventCreateEventRes {
  code?: number;
  msg?: string;
  nonce?: string;
  data: Data;
}
export interface Data {
  /**
   * 活动ID
   */
  event_id?: string;
}

const DashboardEventCreateEvent = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<DashboardEventCreateEventRes>(
    '/wemeet-tapi',
    '/v2/activities/dashboard/event/create-event',
    data,
    ctx,
  );

  return res;
};

export default DashboardEventCreateEvent;
